export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Название: "])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сохранить"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Назад"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пожалуйста, укажите новое название для актива"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Это название поможет вам легче идентифицировать кошелёк в списке активов."])}
}